import {Model} from 'backbone';

class Metadata extends Model.extend({
  defaults: {
    count: 0
  }
}) {}

export default Metadata;
